<template>
  <div class="mt-2">
    <!-- Ya hay referencia (se volvio del widget con el pago hecho). -->
    <div v-if="store.datafastReference" class="pos-change pos-change-ok">
      <span><i class="fa-solid fa-circle-check me-1" aria-hidden="true"></i>{{ $t('pos.lbl_datafast_ready') }}</span>
    </div>

    <template v-else>
      <button
        type="button"
        class="btn btn-primary btn-sm w-100 pos-tap"
        :disabled="loading || store.estimatedTotal <= 0"
        @click="startCheckout"
      >
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i class="fa-solid fa-credit-card me-1" aria-hidden="true"></i>{{ $t('pos.lbl_datafast_pay') }} · {{ money(store.estimatedTotal) }}
      </button>
      <AlertMessage class="mt-2 mb-0" :message="error" />
    </template>

    <!-- Widget de Datafast: se monta el formulario de tarjeta; al pagar redirige
         al POS con el resourcePath, que se toma como referencia del cobro. -->
    <PosModal v-model="show" :title="$t('pos.lbl_pay_datafast')" :done-label="$t('pos.lbl_cancel')" :close-label="$t('pos.lbl_cancel')">
      <p class="text-muted small mb-2">{{ $t('pos.lbl_datafast_widget_help') }}</p>
      <form :action="returnUrl" class="paymentWidgets" data-brands="VISA MASTER DINERS DISCOVER AMEX"></form>
    </PosModal>
  </div>
</template>

<script setup>
import { nextTick, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import AlertMessage from './AlertMessage.vue'
import PosModal from './PosModal.vue'
import { usePos } from '../../store/pos'
import { posRequest } from '../usePosRequest'
import { POS_DATAFAST_CHECKOUT } from '../constants/pos'
import { money } from '../money'

const store = usePos()
const { t } = useI18n()

const show = ref(false)
const loading = ref(false)
const error = ref('')

// Al pagar, Datafast redirige aqui con `resourcePath` en la URL (lo lee PosScreen).
const returnUrl = `${window.location.origin}/quick-booking?mode=pos`

const startCheckout = async () => {
  loading.value = true
  error.value = ''

  const res = await posRequest(POS_DATAFAST_CHECKOUT(), {
    amount: store.estimatedTotal,
    iva: store.taxAmount,
    base_imponible: store.taxableBaseEstimate
  })

  loading.value = false

  if (!res.ok || !res.data || !res.data.widget_url) {
    error.value = res.message || t('pos.lbl_unexpected_error')
    return
  }

  // Se preserva el carrito: el widget redirige y perderia el estado del SPA.
  store.saveDraft()

  show.value = true

  // Inyecta el script del widget DESPUES de que el <form> este en el DOM.
  await nextTick()
  const script = document.createElement('script')
  script.src = res.data.widget_url
  script.async = true
  document.head.appendChild(script)
}
</script>
